import type { InferenceApp, InferenceAppId } from './types';

/**
 * Seed data for the GraphClaw Hub, in the normalized `*ById` + `Ids[]` shape.
 *
 * Intentionally empty: the hub starts with no inference apps (the empty state shows),
 * and apps appear as the user creates them. When a backend exists, `service.ts` will
 * populate these from a fetched response instead.
 */
export const inferenceAppsByIdFixture: Record<InferenceAppId, InferenceApp> = {};

export const inferenceAppIdsFixture: InferenceAppId[] = [];
